import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import Reveal from "@/components/Reveal";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/newsletter", { email });
      setDone(true);
      toast.success("You're on the list. Right place, right time.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section data-testid="newsletter-section" className="relative overflow-hidden px-5 py-28 sm:px-8 sm:py-36">
      <span className="pointer-events-none absolute -right-8 top-1/2 hidden -translate-y-1/2 select-none font-display text-[16rem] font-extrabold leading-none text-bone/[0.03] lg:block">
        555
      </span>
      <div className="mx-auto max-w-4xl">
        <Reveal>
          <p className="font-mono text-[10px] tracking-[0.35em] text-fade">NEWSLETTER</p>
          <h2 className="mt-4 font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-bone sm:text-6xl lg:text-7xl">
            Right place.
            <br />
            Right time.
          </h2>
          <p className="mt-6 max-w-md text-base font-light text-neutral-400">Get notified when the next alignment happens.</p>
        </Reveal>
        <Reveal delay={0.15}>
          {done ? (
            <p data-testid="newsletter-success" className="mt-10 border border-white/15 bg-coal/60 p-6 font-mono text-xs tracking-[0.3em] text-bone">
              SIGNAL RECEIVED. STAY ALIGNED. ✦
            </p>
          ) : (
            <form onSubmit={submit} className="mt-10 flex max-w-lg flex-col gap-3 sm:flex-row">
              <input
                data-testid="newsletter-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                className="flex-1 border border-white/20 bg-transparent px-5 py-4 font-mono text-sm text-bone placeholder:text-bone/30 focus:border-bone focus:outline-none"
              />
              <button
                data-testid="newsletter-submit-button"
                type="submit"
                disabled={busy}
                className="bg-bone px-8 py-4 font-display text-sm font-extrabold uppercase tracking-[0.2em] text-ink transition-opacity hover:opacity-90 disabled:opacity-50"
              >
                {busy ? "…" : "STAY ALIGNED →"}
              </button>
            </form>
          )}
        </Reveal>
      </div>
    </section>
  );
}
